export const main_background_color = '';

export const backend_url = process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_BACKEND_URL_PROD
    : process.env.REACT_APP_BACKEND_URL_DEV;

export const api_endpoints = {
    // Users endpoints
    create_user: `${backend_url}/api/users/register`,

    // Events endpoints
    create_event: `${backend_url}/api/events`,
    submit_event_data: `${backend_url}/api/events/`,

    // Board endpoints
    get_board_by_board: (boardNum) => `${backend_url}/api/boards/${boardNum}`,
    get_todays_board: `${backend_url}/api/boards/today`,
    get_all_boards: `${backend_url}/api/boards`,
}

// A local, hand-designed board (never fetched from the backend, never appears in
// the archive) used to walk brand-new players through the mechanic once, on
// easier terms than whatever today's real board happens to be. boardNum is the
// non-numeric string 'tutorial' - a real board number is always an integer, so
// this can never collide with one, and getPlayedBoardNumbers() explicitly filters
// non-numeric keys out of streak/archive logic.
// Solution: +2 (1->3), +2,+1 (3->6), -1,-1 (6->4) - 5 moves, no multiply/divide.
export const tutorial_board = {
    boardNum: 'tutorial',
    targetNums: [1, 3, 6, 4],
    operators: ['+2', '+1', '-1'],
    solution_length: 5,
};

